<template>
  <FriedTableRow
    :key="template.id"
    :data-external="`dsr-template-picker-table-template-id:${template.id}-table-row`"
  >
    <TypeCell
      :enable-min-width="false"
      :color="RainbowColor.Purple"
      icon="template"
      :tooltip-text="$t('dsr_content_library_room_template')"
    />
    <NameCell
      :resource="template"
      @click="$emit('create-from-template', { id: $event.contentId, name: $event.title })"
    />
    <TagTableCell
      v-if="hasTagFlag"
      :categories="categories"
      :resource-id="template.id"
      :tags="template.tagIds || []"
      class="hidden-xs-and-down"
    />
    <FriedTableCell class="hidden-md-and-down">
      {{ usedCountText }}
    </FriedTableCell>
    <DateCell
      class="hidden-sm-and-down"
      :date="convertToISODate(template.updatedAt)"
      :user-name="template.updatedBy.fullName"
    />
  </FriedTableRow>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import { RainbowColor } from '@getaccept/fried-tofu';
import TypeCell from '@getaccept/lib-shared/src/library/components/TypeCell.vue';
import DateCell from '@getaccept/lib-shared/src/library/components/DateCell.vue';
import NameCell from '@getaccept/lib-shared/src/library/components/NameCell.vue';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { ContentTagCategory } from '@getaccept/dsr-shared';
import { TagTableCell } from '@getaccept/dsr-shared';

export default defineComponent({
  name: 'TemplateRow',
  components: {
    NameCell,
    TypeCell,
    DateCell,
    TagTableCell,
  },
  props: {
    template: {
      type: Object as PropType<DsrResource>,
      required: true,
    },
    hasTagFlag: {
      type: Boolean,
    },
    categories: {
      type: Array as PropType<ContentTagCategory[]>,
      default: () => [],
    },
  },
  emits: ['create-from-template'],
  setup(props) {
    const usedCountText = computed(() =>
      t('dsr-content-lib__n_times', { num: props.template.statistics.useCount })
    );

    return {
      RainbowColor,
      usedCountText,
      convertToISODate: LibraryHelper.convertToISODate,
    };
  },
});
</script>
<style lang="scss" scoped>
.table-cell.left:first-child {
  padding-left: var(--spacing-100);
}
</style>
